import { render, staticRenderFns } from "./BannerHm.vue?vue&type=template&id=4373c2c2&scoped=true&"
import script from "./BannerHm.vue?vue&type=script&lang=js&"
export * from "./BannerHm.vue?vue&type=script&lang=js&"
import style0 from "./BannerHm.vue?vue&type=style&index=0&id=4373c2c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4373c2c2",
  null
  
)

export default component.exports